import React, { useEffect, useState } from "react";
import "../components/question.css";
import SearchableDialog from "./SearchableDialog";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import {
  addAnswer,
  addWriteIn,
  clearAnsweres,
} from "../../../../redux/survey/actions";
import { useIntl } from "react-intl";

const DropdownType = (props) => {
  const intl = useIntl();
  // Destructuring props
  const { question, answeres, addAnswer_, survey_theme, onSend, edit_answer } =
    props;

  // State variables
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState("");
  const [checkedText, setCheckedText] = useState("");

  // Function to handle option change
  const handleChange = (ratingId, optionValue, text) => {
    setChecked(ratingId);
    setCheckedText(text);

    addAnswer_({
      id: question._id,
      value: ratingId,
      type: "id",
    });
    // Normal flow - auto submit and proceed
    onSubmitAnswer({
      checkedText: text,
      checked: ratingId,
    });
  };

  const onSubmitAnswer = ({ checkedText, checked }) => {
    if (question?.required && !checked) {
      toast.error(intl.formatMessage({ id: "this-question-is-required" }));
      return;
    } else {
      const selectedOption = question?.options?.find(
        (opt) => opt?._id === checked
      );
      // Check if image is required for the selected option
      if (selectedOption?.image_required) {
        const questionImages = answeres[question._id]?.image;
        if (!questionImages || questionImages.length === 0) {
          toast.error(intl.formatMessage({ id: "image-is-required" }));
          setOpen(false);
          return;
        }
      }

      onSend(checkedText);
      setOpen(false);
    }
  };

  // Skip the current question
  const onSkipQuestion = () => {
    onSend(checkedText);
    setOpen(false);
  };

  // Function to load data from Redux store when component mounts
  const loadData = () => {
    if (question._id in answeres) {
      setChecked(answeres[question._id]?.value);
    }
    if (edit_answer && Object?.keys(edit_answer)?.length) {
      setOpen(true);
      const selectedOption = question?.options?.find(
        (opt) => opt?._id === answeres[question._id]?.value
      );
      // Check if image is required for the selected option
      if (selectedOption?.image_required) {
        const questionImages = answeres[question._id]?.image;
        if (!questionImages || questionImages.length === 0) {
          setOpen(false);
          return;
        }
      }
    }
  };

  useEffect(() => {
    loadData(); // Load data from Redux store when component mounts
  }, [answeres]);

  // Handle dialog close
  const handleClose = () => {
    setOpen(false);
  };

  // Handle option selection
  const handleOptionSelect = (option) => {
    handleChange(option._id, option.value, option.text);
  };

  return (
    <>
      <div className="px-4 bg-white border-t border-gray-200">
        <div className="flex items-center space-x-3 h-18">
          <button
            onClick={() => setOpen(true)}
            type="button"
            className="inline-flex items-center justify-center flex-1 px-3 py-2.5 text-sm font-medium leading-4 transition-all duration-200 bg-transparent border border-purple-600 rounded-full shadow-sm hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-600"
            style={{ color: survey_theme?.primaryColor }}
            data-toggle="modal"
            data-target="#selectSkills"
          >
            <svg
              className="w-5 height-1 mr-3"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
              <path
                fillRule="evenodd"
                d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                clipRule="evenodd"
              />
            </svg>
            {intl.formatMessage({ id: "select" })}
          </button>
          {!question?.required ? (
            <button
              onClick={() => onSkipQuestion()}
              type="button"
              className="inline-flex items-center justify-center flex-1 px-3 py-2.5 text-sm font-medium leading-4 transition-all duration-200 bg-transparent border border-purple-600 rounded-full shadow-sm hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-600"
            >
              {intl.formatMessage({ id: "skip" })}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
      <SearchableDialog
        open={open}
        onClose={handleClose}
        title={intl.formatMessage({ id: "select" })}
        options={question?.options || []}
        selectedValue={checked}
        onOptionSelect={handleOptionSelect}
        primaryColor={survey_theme?.primaryColor}
      />
    </>
  );
};
// Redux mapping function to map state to props
const mapStateToProps = (state) => {
  return {
    answeres: state.survey.answeres,
    edit_answer: state.survey.edit_answer,
  };
};
// Redux mapping function to map dispatch to props
const mapDispatchToProps = (dispatch) => {
  return {
    addAnswer_: (data) => dispatch(addAnswer(data)),
    addWriteIn_: (data) => dispatch(addWriteIn(data)),
    clearAnsweres_: () => dispatch(clearAnsweres()),
  };
};
// Connects the DropdownType component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(DropdownType);
